import { render } from "./CIS-Resource-Advisory-AffectedSystem.vue?vue&type=template&id=e19a2f24"
import script from "./CIS-Resource-Advisory-AffectedSystem.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-Advisory-AffectedSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__